export default __webpack_public_path__ + "static/media/1.d2ab17c7.png";